import React from 'react';
import { Radio } from 'lucide-react';

export const ListenLiveButton = ({ radioSettings, isRadioActive, toggleRadio }) => {
  if (!radioSettings?.is_active) return null;

  return (
    <button
      onClick={toggleRadio}
      className="group relative"
      data-testid="radio-toggle-btn"
    >
      {/* Audio visualizer bars - orbit around button when active */}
      {isRadioActive && (
        <div className="absolute -inset-3 rounded-full pointer-events-none">
          {[...Array(12)].map((_, i) => (
            <div
              key={`viz-${i}`}
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                width: '3px',
                borderRadius: '2px',
                background: `linear-gradient(to top, #f97316, ${i % 3 === 0 ? '#22c55e' : i % 3 === 1 ? '#eab308' : '#f97316'})`,
                transformOrigin: 'bottom center',
                transform: `rotate(${i * 30}deg) translateY(-22px)`,
                animation: `visualizer-pulse ${0.4 + (i % 4) * 0.15}s ease-in-out ${i * 0.05}s infinite alternate`,
                opacity: 0.85,
              }}
            />
          ))}
        </div>
      )}

      {/* Outer glow ring when active */}
      {isRadioActive && (
        <div className="absolute -inset-1 rounded-full animate-spin" style={{ animationDuration: '8s' }}>
          <div className="absolute inset-0 rounded-full" style={{
            background: 'conic-gradient(from 0deg, transparent 0%, rgba(249,115,22,0.4) 25%, transparent 50%, rgba(34,197,94,0.4) 75%, transparent 100%)',
            filter: 'blur(4px)',
          }} />
        </div>
      )}

      {/* Animated background gradient */}
      <div className={`absolute inset-0 rounded-full transition-all duration-500 ${
        isRadioActive 
          ? 'opacity-100' 
          : 'opacity-0 group-hover:opacity-100'
      }`}>
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-orange-500 via-yellow-500 to-green-500 animate-gradient-x" />
        <div className="absolute inset-[2px] rounded-full bg-black/80" />
      </div>
      
      {/* Button content */}
      <div className={`relative flex items-center gap-2.5 px-6 py-3 rounded-full transition-all duration-300 ${
        isRadioActive
          ? 'border-transparent text-white' 
          : 'text-orange-400 hover:text-white bg-black/40 backdrop-blur-sm'
      }`}>
        <Radio className={`w-5 h-5 transition-transform duration-300 ${
          isRadioActive ? 'scale-110' : 'group-hover:scale-110'
        }`} />
        <span className="text-base font-bold tracking-wider uppercase">
          {isRadioActive ? 'LIVE' : 'Listen Live'}
        </span>
        
        {/* Pulsing live indicator */}
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
        </span>
      </div>
    </button>
  );
};
